import { ClerkProvider } from "@clerk/nextjs";
import { dark } from "@clerk/themes";
import { useComputedColorScheme } from "@mantine/core";
import type { ReactNode } from "react";

/**
 * Needs to be slightly decoupled from `_app.tsx` so that we decouple and don't get a "Mantine theme wasn't defined in this component yet"
 */
export const ClerkWrapper = ({ children }: { children: ReactNode[] }) => {
  const colorScheme = useComputedColorScheme();
  return (
    <ClerkProvider
      dynamic={true}
      appearance={{
        baseTheme: colorScheme === "dark" ? dark : undefined, // undefined => default light theme
      }}
    >
      {children}
    </ClerkProvider>
  );
};
